module.exports = __webpack_public_path__ + "media/images/forms-icons/date-icon-b16c0efad02049823e224aedccb0ad05.svg";